import { supabase } from "../../supabase/supabase";
import * as Sentry from "@sentry/react";

const API_BASE_URL = import.meta.env.VITE_CALL_SERVICE_URL || "http://localhost:8000";

export interface ProviderBalance {
  provider: string;
  status: "success" | "error" | "not_available";
  balance?: number;
  currency?: string;
  details?: Record<string, any>;
  error_message?: string;
}

export interface CreditsBalanceResponse {
  organization_id: string;
  balances: ProviderBalance[];
  fetched_at: string;
}

export const creditsService = {
  async getCreditsBalance(
    organizationId: string,
  ): Promise<CreditsBalanceResponse> {
    try {
      // Get the session to include auth token
      const {
        data: { session },
      } = await supabase.auth.getSession();

      const response = await fetch(
        `${API_BASE_URL}/api/credits/balance/${organizationId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            ...(session?.access_token && {
              Authorization: `Bearer ${session.access_token}`,
            }),
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.detail || `Failed to fetch credits balance: ${response.status}`,
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      Sentry.logger.error("Error fetching credits balance", {
        error,
        log_source: "credits_service",
        organization_id: organizationId,
      });
      throw error;
    }
  },
};
